type Tone = "primary" | "accent" | "secondary" | "warning";

const tones: Record<Tone, string> = {
  primary: "bg-primary-50 text-primary-700",
  accent: "bg-accent-50 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
  warning: "bg-warning-50 text-warning-700",
};

interface StatCardProps {
  label: string;
  value: string;
  icon: string;
  tone?: Tone;
  hint?: string;
  trend?: string;
}

/** Chiffre clé : libellé, valeur (sans retour à la ligne disgracieux), précision. */
export default function StatCard({ label, value, icon, tone = "primary", hint, trend }: StatCardProps) {
  return (
    <div className="min-w-0 rounded-lg border border-background-200 bg-background-50 p-4 shadow-card sm:p-5">
      <div className="flex items-start justify-between gap-3">
        <p className="min-w-0 text-sm font-medium text-foreground-600">{label}</p>
        <span className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center ${tones[tone]}`} aria-hidden="true">
          <i className={`${icon} text-lg`}></i>
        </span>
      </div>
      <p className="mt-2 text-xl font-semibold font-heading tabular-nums text-foreground-950 break-words sm:text-2xl">{value}</p>
      {(hint || trend) && (
        <p className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
          {trend && (
            <span className="inline-flex items-center gap-0.5 font-medium text-primary-700">
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
              {trend}
            </span>
          )}
          {hint}
        </p>
      )}
    </div>
  );
}
